var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';

/**
 * Convert a string from camelCase to kebab-case
 * @param {string} string - The base string (ostensibly camelCase)
 * @return { string } - A kebab-case string
 */
var toKebabCase = function toKebabCase(string) {
  return string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
};

/** @type {Symbol} - Used to save reference to active listeners */
var listeners = Symbol('jsx-native-events/event-listeners');

var eventPattern = /^onEvent/;

export default function jsx(type, props) {
  var newProps = _extends({}, props);
  if (typeof type === 'string') {
    newProps.ref = function (element) {
      // merge existing ref prop
      if (props && props.ref) {
        if (typeof props.ref === 'function') {
          props.ref(element);
        } else if (_typeof(props.ref) === 'object') {
          props.ref.current = element;
        }
      }

      if (element) {
        if (props) {
          var keys = Object.keys(props);
          /** Get all keys that have the `onEvent` prefix */
          keys.filter(function (key) {
            return key.match(eventPattern);
          }).map(function (key) {
            return {
              key: key,
              eventName: toKebabCase(key.replace('onEvent', '')).replace('-', '')
            };
          }).map(function (_ref) {
            var eventName = _ref.eventName,
                key = _ref.key;

            /** Add the listeners Map if not present */
            if (!element[listeners]) {
              element[listeners] = new Map();
            }

            /** If the listener hasn't be attached, attach it */
            if (!element[listeners].has(eventName)) {
              element.addEventListener(eventName, props[key]);
              /** Save a reference to avoid listening to the same value twice */
              element[listeners].set(eventName, props[key]);
            }
          });
        }
      }
    };
  }

  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  return React.createElement.apply(null, [type, newProps].concat(children));
}